const ObjectTypeDetail = `
  fragment ObjectTypeDetail on ObjectTypeDetail {
    id
    name
  }
`
export default ObjectTypeDetail
